export const GET_REPORTED_REELS = "GET_REPORTED_REELS";
export const DISMISS_REEL_REPORT = "DISMISS_REEL_REPORT";
export const DELETE_REPORTED_REEL = "DELETE_REPORTED_REEL";
